if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

/* SuperTots CRO fix (2026-08-26): the Judge.me reviews widget was being injected INTO the
   cart drawer, between the cart items and the Checkout button, pushing checkout far down the
   page on mobile. Hide the reviews widget inside the cart drawer ONLY (product-page reviews
   are untouched) so the Checkout button sits right after the cart items. */
(function () {
  if (document.getElementById('supertots-cart-drawer-reviews-fix')) return;
  var style = document.createElement('style');
  style.id = 'supertots-cart-drawer-reviews-fix';
  style.textContent =
    '#CartDrawer [class*="jdgm"], cart-drawer [class*="jdgm"] { display: none !important; }';
  (document.head || document.documentElement).appendChild(style);
})();

/* SuperTots CRO (2026-08-28 v2): per-market free-shipping bar + announcement-bar sync.
   THRESHOLD markets (shipping paid below $20 USD, free at/above): US, GB, AU, CA, NZ + the
   whole "EU" shipping zone + ALL standalone European country markets (FR/DE/ES/IT/NL/AT/DK/SE/
   BE/CY/GR/IE/PL/PT/CH — Standard set to $1.99 / free-over-$20 on 2026-08-28) —
   show "you're <local> away from FREE shipping". <local> = $20 USD converted live via
   window.Shopify.currency.rate, rounded UP to a whole unit so the displayed threshold is
   always >= the real checkout threshold (never over-promises free shipping).
   FREE markets (standard shipping still free, no minimum): only Rest-of-World / International /
   Singapore — show "FREE shipping on all orders" (no fake threshold).
   Also rewrites the announcement-bar "FREE SHIPPING..." text to match each market.
   Cart total read from /cart.js (currency-agnostic cents). Reversible: remove this block. */
(function () {
  var BASE_USD = 20;
  var ID = 'supertots-freeship-bar', SID = 'supertots-freeship-css';
  // Countries whose shipping is PAID below the $20 threshold and FREE at/above it.
  // = primary zones (US/UK/AU/CA/NZ) + the entire "EU" shipping zone (Std $1.99, free >$20).
  var THRESHOLD = {
    US: 1, GB: 1, AU: 1, CA: 1, NZ: 1,
    FR: 1, DE: 1, ES: 1, IT: 1, NL: 1, AT: 1, DK: 1, SE: 1, BE: 1, CY: 1, GR: 1, IE: 1, PL: 1, PT: 1, CH: 1,
    AX: 1, AL: 1, AD: 1, AM: 1, BY: 1, BA: 1, BG: 1, HR: 1, CZ: 1, EE: 1, FO: 1, FI: 1,
    GE: 1, GI: 1, GL: 1, GP: 1, GG: 1, HU: 1, IS: 1, IM: 1, JE: 1, XK: 1, LV: 1, LI: 1,
    LT: 1, LU: 1, MT: 1, YT: 1, MD: 1, MC: 1, ME: 1, MK: 1, NO: 1, RE: 1, RO: 1, SM: 1,
    RS: 1, SK: 1, SI: 1, SJ: 1, TR: 1, UA: 1, VA: 1
  };
  // 2026-10-01: fixed local thresholds set in Shopify shipping (country: [amount, currency]).
  // Anything not listed (US, the mixed "EU" zone) keeps $20 USD converted + rounded up.
  var LOCAL = {
    GB: [15, 'GBP'], CA: [29, 'CAD'], AU: [29, 'AUD'], NZ: [36, 'NZD'],
    DE: [18, 'EUR'], FR: [18, 'EUR'], IT: [18, 'EUR'], ES: [18, 'EUR'], NL: [18, 'EUR'], AT: [18, 'EUR'],
    BE: [18, 'EUR'], IE: [18, 'EUR'], PT: [18, 'EUR'], GR: [18, 'EUR'], CY: [18, 'EUR'],
    DK: [135, 'DKK'], SE: [205, 'SEK'], CH: [17, 'CHF'], PL: [78, 'PLN']
  };
  var ob = null, sc = false;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function info() {
    var c = (window.Shopify && window.Shopify.country) || '';
    if (THRESHOLD[c]) {
      var cur = (window.Shopify && window.Shopify.currency) || {};
      var rate = parseFloat(cur.rate || '1'); if (!(rate > 0)) rate = 1;
      var active = cur.active || 'USD';
      // 2026-10-01: markets with a fixed local free-shipping threshold (matches Shopify shipping rates).
      var loc = LOCAL[c];
      var displayMajor = (loc && loc[1] === active) ? loc[0] : Math.ceil(BASE_USD * rate);
      return { type: 'threshold', active: active, cents: Math.round(displayMajor * 100) };
    }
    return { type: 'free' };
  }
  function money(cents, active, dp) {
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: active, currencyDisplay: 'narrowSymbol', minimumFractionDigits: dp, maximumFractionDigits: dp }).format(cents / 100);
    } catch (e) {
      return (active === 'USD' ? '$' : active + ' ') + (cents / 100).toFixed(dp);
    }
  }
  function css() {
    if (document.getElementById(SID)) return;
    var s = document.createElement('style'); s.id = SID;
    s.textContent =
      '#' + ID + '{margin:0 0 1.2rem;padding:12px 14px;border-radius:12px;background:rgba(var(--color-foreground),.06);font-size:1.35rem;line-height:1.35}' +
      '#' + ID + ' .stfs-m{margin-bottom:8px;color:rgb(var(--color-foreground))}' +
      '#' + ID + ' .stfs-t{height:8px;border-radius:999px;background:rgba(var(--color-foreground),.15);overflow:hidden}' +
      '#' + ID + ' .stfs-f{height:100%;width:0;border-radius:999px;background:#1a8a5a;transition:width .35s ease}' +
      '#' + ID + '.stfs-free{background:rgba(26,138,90,.10)}' +
      '#' + ID + '.stfs-free .stfs-t{display:none}' +
      '#' + ID + '.stfs-free .stfs-m{margin-bottom:0}';
    (document.head || document.documentElement).appendChild(s);
  }
  function render(cart) {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    var it = d.querySelector('cart-drawer-items');
    var ex = d.querySelector('#' + ID);
    if (!it || d.classList.contains('is-empty') || !cart || cart.item_count === 0) { if (ex) ex.remove(); return; }
    var nfo = info();
    var msgHTML, pct, isFree = (nfo.type === 'free');
    if (isFree) {
      msgHTML = '🎉 <strong>FREE shipping</strong> on all orders';
      pct = 0;
    } else {
      var totCents = cart.total_price;
      var rem = nfo.cents - totCents;
      pct = Math.max(0, Math.min(100, Math.round(totCents / nfo.cents * 100)));
      msgHTML = rem > 0
        ? "You're <strong>" + money(rem, nfo.active, 2) + "</strong> away from <strong>FREE shipping</strong> 🚚"
        : "🎉 <strong>You've unlocked FREE shipping!</strong>";
    }
    var st = nfo.type + '|' + pct + '|' + msgHTML;
    var b = ex;
    if (!b) {
      b = document.createElement('div'); b.id = ID;
      b.innerHTML = '<div class="stfs-m"></div><div class="stfs-t"><div class="stfs-f">​</div></div>';
      it.parentNode.insertBefore(b, it);
    }
    if (b.dataset.state === st) return;
    b.dataset.state = st;
    b.classList.toggle('stfs-free', isFree);
    b.querySelector('.stfs-m').innerHTML = msgHTML;
    if (!isFree) b.querySelector('.stfs-f').style.width = pct + '%';
  }
  function announce() {
    var nfo = info();
    var txt = (nfo.type === 'threshold')
      ? 'FREE SHIPPING FOR ORDERS OVER ' + money(nfo.cents, nfo.active, 0)
      : 'FREE SHIPPING ON ALL ORDERS';
    var msgs = document.querySelectorAll('.announcement-bar__message');
    for (var i = 0; i < msgs.length; i++) {
      var m = msgs[i];
      if (!/free\s*ship/i.test(m.textContent || '')) continue;
      var span = m.querySelector('span') || m;
      if ((span.textContent || '').trim() !== txt) span.textContent = txt;
    }
  }
  function sch() {
    if (sc) return; sc = true;
    setTimeout(function () {
      sc = false;
      if (ob) ob.disconnect();
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { try { css(); render(cart); announce(); } catch (e) { console.error('[supertots freeship]', e); } })
        .catch(function () { try { css(); announce(); } catch (e) {} })
        .then(function () { so(); });
    }, 60);
  }
  function so() {
    var d = document.querySelector('cart-drawer'); if (!d) return;
    if (!ob) ob = new MutationObserver(function () { sch(); });
    ob.observe(d, { childList: true, subtree: true });
  }
  function init() {
    css(); announce(); sch();
    setTimeout(announce, 400); setTimeout(announce, 1400);
    document.addEventListener('cartdrawer:opened', sch);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
